import { render, staticRenderFns } from "./BookingAdminOrder.vue?vue&type=template&id=61735427&"
import script from "./BookingAdminOrder.vue?vue&type=script&lang=js&"
export * from "./BookingAdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports